import React, { useState } from 'react';
import MatchTypeModal from '../matches/MatchTypeModal';
import './LogMatchFab.css';

/**
 * Mobile-only floating action button for the app's core action: logging a match.
 *
 * Previously this took drawer → button → modal. The FAB collapses that to a
 * single tap, reusing the existing MatchTypeModal (which already respects the
 * user's game preferences). Hidden on desktop via CSS.
 */
const LogMatchFab = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="log-match-fab"
        onClick={() => setOpen(true)}
        aria-label="Log a match"
      >
        <i className="fas fa-plus" aria-hidden="true" />
      </button>
      {open && <MatchTypeModal onClose={() => setOpen(false)} />}
    </>
  );
};

export default LogMatchFab;
